// Umrechnung zwischen Farbton/Sättigung/Helligkeit und Hex.
// Reine Rechnung ohne DOM — die Farbwahl im Anschreiben-Editor braucht beide
// Richtungen: die Fläche rechnet in HSV, gespeichert wird Hex.

/** @param {number} h 0..359 @param {number} s 0..1 @param {number} v 0..1 */
export function hsvNachHex(h, s, v) {
  const f = (n) => {
    const k = (n + h / 60) % 6;
    const x = v - v * s * Math.max(0, Math.min(k, 4 - k, 1));
    return Math.round(x * 255).toString(16).padStart(2, '0');
  };
  return `#${f(5)}${f(3)}${f(1)}`;
}

/** Ungültige Eingaben ergeben ein dunkles Grau statt eines Absturzes. */
export function hexNachHsv(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec((hex || '').trim());
  if (!m) return { h: 0, s: 0, v: 0.07 };
  const n = parseInt(m[1], 16);
  const r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min;
  let h = 0;
  if (d) {
    if (max === r) h = ((g - b) / d) % 6;
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h = (h * 60 + 360) % 360;
  }
  return { h, s: max ? d / max : 0, v: max };
}
